<template>
    <div class="topic-right fr">

        <div
            class="top-item"
            v-for="(item,index) in list"
            :key="'top-item-'+index"
        >

            <layout-title :title="item.title"/>

            <div v-if="item.key !== 'star'">
                <layout-item
                    v-for="(cItem,cIndex) in data[item.key]"
                    :key="item.key + 'item-' + cIndex"
                    :data="cItem"
                    :tag="item.tag"
                    :keyword="item.key"
                    @open="openPage(item,cItem)"
                />
            </div>

            <div v-else class="cf star-box">

                <star-avatar-item
                    class="fl star-item"
                    v-for="(cItem,cIndex) in data[item.key]"
                    :key="item.key + 'item-' + cIndex"
                    :data="cItem"
                />

            </div>

        </div>

    </div>
</template>

<script>
import mixin from "./mixin/mixin";
import LayoutTitle from '../layout-title/main';
import LayoutItem from '../layout-item/main';
import starAvatarItem from '../starAvatarItem/main';
export default {
    name: "layout-right-list",
    mixins: [mixin],
    components: {
        LayoutTitle,
        LayoutItem,
        starAvatarItem
    }
}
</script>

<style scoped src="./style.css"></style>
